import { CryptoWorkerService } from "./crypto.service";

// Export singleton instance
export const CRYPTO_SERVICE = CryptoWorkerService.getInstance();

export * from "./interfaces";
